module.exports = __webpack_public_path__ + "media/application/images/external-services/facebook-logo-015acce9dbeda8389c97b7ff321eaee8.svg";